<template lang="html">
  <videointerview
    v-if="isRecordingTestComplete && loaded && resolutionsLoaded"
    :interview="interview"
    :is-videoresume="isVideoresume"
  />

  <recording-test
    v-else-if="loaded && resolutionsLoaded"
    :interview="interview"
    :is-videoresume="isVideoresume"
    @recording-test-complete="completeRecordingTest"
  />
</template>

<script>
import RecordingTest from '../equipmentCheck/RecordingTest';
import Videointerview from './Videointerview';

export default {
  name: 'InterviewVideointerviewSceneContent',

  components: {
    Videointerview,
    RecordingTest
  },

  props: {
    interview: Object,
    isVideoresume: Boolean
  },

  data() {
    return {
      isRecordingTestComplete: false,
      loaded: false,
      resolutionsLoaded: false,
      videoDevices: []
    };
  },

  computed: {
    questions() {
      return this.$store.getters['interview/videointerview/questions'];
    },

    isVideoAnswerEnabled() {
      return this.$store.getters['interview/videointerview/isVideoAnswerEnabled'];
    },

    quickScan() {
      return this.$store.getters['interview/videointerview/quickScan'];
    },

    is_videointerview_started() {
      if (!this.questions || !this.questions.length) {
        return false;
      }

      return this.questions.find(item => (item ? item.is_shown : false));
    }
  },

  watch: {
    is_videointerview_started: {
      immediate: true,
      handler(val) {
        if (val) {
          this.completeRecordingTest();
        }
      }
    }
  },

  beforeMount() {
    this.getResolution();
  },

  created() {
    this.get_interview();
  },

  beforeDestroy() {
    this.$store.commit('interview/videointerview/clearEnabledResolutions');
  },

  methods: {
    completeRecordingTest() {
      this.isRecordingTestComplete = true;
    },

    get_interview() {
      this.interview.token &&
        this.$store
          .dispatch('interview/videointerview/fetch', {
            interview: this.interview
          })
          .finally(() => {
            this.loaded = true;
          });
    },

    getResolution() {
      if (!this.isVideoAnswerEnabled) {
        this.resolutionsLoaded = true;
        return;
      }

      navigator.mediaDevices.enumerateDevices().then(devices => {
        devices.forEach(device => {
          if (device && device.kind == 'videoinput') {
            this.videoDevices.push(device.deviceId);
          }
        });
        this.$store.commit('interview/videointerview/setDevices', this.videoDevices);

        this.getUserMedia(0);
      });
    },

    getUserMedia(index) {
      const orientation = window.innerWidth > window.innerHeight ? 'horizontal' : 'vertical';

      if (index > this.quickScan.length - 1) {
        return;
      }

      const item = this.quickScan[index];

      let constraints = {
        audio: false,
        video: {
          facingMode: { exact: 'user' },
          width: { exact: orientation === 'horizontal' ? item.width : item.height },
          height: { exact: orientation === 'horizontal' ? item.height : item.width },
          deviceId: { exact: this.videoDevices[0] }
        }
      };

      console.log(constraints);

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(stream => {
          this.$store.commit('interview/videointerview/setEnabledResolutions', item);
          if (item.ratio !== '16:9') {
            this.getUserMedia(index + 1);
          }
          this.resolutionsLoaded = true;

          if (stream) {
            const tracks = stream.getTracks();
            tracks.forEach(track => track.stop());
          }
        })
        .catch(() => {
          this.getUserMedia(index + 1);
          if (index === this.quickScan.length - 1) {
            this.resolutionsLoaded = true;
            return;
          }
        });
    }
  }
};
</script>
